import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {GlobalSettingsService} from '../../services/ui/global-settings.service';
import {BinderSessionWizardService} from '../../services/sections/binder/binder-session-wizard.service';
import {ToastService} from '../../services/ui/toast.service';
import {ToastType} from '../../components/toast/models/toast-type.enum';

@Injectable({
	providedIn: 'root',
})
export class BinderSessionCodeResolver implements Resolve<boolean> {
	constructor(
		private router: Router,
		private binderWizardService: BinderSessionWizardService
	) {}

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
		GlobalSettingsService.isGlobalLoaderLoading = true;
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const token = activatedRouteSnapshot.paramMap.get('token');
		const confirmationCode = activatedRouteSnapshot.paramMap.get('code');


		if (!token || !confirmationCode) {
			this.router.navigate(['/404']);
			return of(false);
		}

		return this.binderWizardService.confirmCode(token, confirmationCode).pipe(
			map(() => {
				this.router.navigate(['/', token]);
				return true;
			}),
			catchError(() => {
				ToastService.pushToast({
					icon: 'error',
					text: 'Invalid confirmation code',
					type: ToastType.Error
				});

				GlobalSettingsService.isGlobalLoaderLoading = false;
				GlobalSettingsService.isSecondaryLoaderLoading = false;
				return of(false);
			})
		);
	}
}
